import { cx } from "class-variance-authority";
import type React from "react";
import { ReactComponent as Svg } from "./assets/arrow-down-2.svg";
import * as styles from "./Icon.module.scss";

type FlucsUpProps = React.SVGProps<SVGSVGElement>;

export const FlucsUp = ({ className, ...props }: FlucsUpProps) => (
  <Svg className={cx(className ?? styles.base, styles.arrowUp)} {...props} />
);
